import React from 'react';
import { css, CSSObject } from '@emotion/css';

import { mqBreakpoints } from '../../system-libraries/styles';
import { pxToRem } from '../../system-libraries/styles/utils';
import Config from '../../system-utils/config-manager';
import { defaultTitle, defaultDescription } from './constants';

type Props = {
  error?: {
    title?: string;
    description?: string;
  };
};

export const ErrorPanel: React.FC<Props> = ({ error }) => {
  const title = error ? error.title : defaultTitle;
  const description = error ? error.description : defaultDescription;

  const onRefreshClick = () => {
    window.location.reload();
  };

  return (
    <div className={css(errorPanelStyle)} data-testid='nba-error-panel'>
      <div className={css(errorPanelLeftStyle)}>
        <img src={Config.get('image_cdn_base_url') + '/ui/shared-component-webapp/inline-error/attention.svg'} />
      </div>
      <div className={css(errorPanelRightStyle)}>
        {title ? <h3 data-testid='nba-error-panel--heading'>{title}</h3> : null}
        <p data-testid='nba-error-panel--refresh-cta'>
          {description ? `${description} Please ` : `Please `}
          <a onClick={onRefreshClick}>refresh the page</a>
          {' to try again.'}
        </p>
      </div>
    </div>
  );
};

const errorPanelStyle: CSSObject = {
  color: 'var(--color-body)',
  display: 'flex',
  flexDirection: 'row',
  margin: 'auto',
  width: '100%',
};

const errorPanelLeftStyle: CSSObject = {
  backgroundColor: 'var(--color-danger)',
  display: 'flex',
  flexDirection: 'column',
  flexShrink: 0,

  img: {
    margin: pxToRem(16),
    marginTop: pxToRem(24),
    width: pxToRem(17),

    [mqBreakpoints.tablet]: {
      margin: pxToRem(28),
      marginTop: pxToRem(32),
      width: pxToRem(24),
    },
  },
};

const errorPanelRightStyle: CSSObject = {
  backgroundColor: 'var(--color-error-container)',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  justifyContent: 'space-between',
  padding: pxToRem(24),
  paddingTop: pxToRem(16),
  paddingBottom: pxToRem(32),

  [mqBreakpoints.tablet]: {
    padding: pxToRem(32),
    paddingTop: pxToRem(24),
  },

  h3: {
    fontWeight: 'var(--font-weight-regular)',
  },

  p: {
    marginTop: pxToRem(-24),
    paddingBottom: 0,
  },
};
